module.exports = __webpack_public_path__ + "media/app-icon-d0593393.jpg";